import React, { useEffect } from "react";
import "./LocationMap.css";

import AOS from "aos";
import "aos/dist/aos.css";

import landMark1 from "../../assets/landMark1.svg";
import landMark2 from "../../assets/Secretariat.svg";
import landMark3 from "../../assets/RayapudiGhat.svg";
import landMark4 from "../../assets/Dhyanabuddha.svg";
import landMark5 from "../../assets/AmaravatiTemple.svg";
import landMark6 from "../../assets/VaikuntapuramtoKotikalapudiIconicBridge.svg";
import landMark7 from "../../assets/AgriculturalResearchCentre.svg";
import landMark8 from "../../assets/SRMUniversity.svg";
import Location from "../../assets/Location Map.png"

const LocationMap = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-in-out" });
  }, []);
  const leftSideImgs = [
    {
      title: "20 min. drive - Vijayawada",
      imageUrl: landMark1,
    },
    {
      title: "15 min. drive - High Court, Secretariat",
      imageUrl: landMark2,
    },
    {
      title: "10 min. drive - Rayapudi Ghat",
      imageUrl: landMark3,
    },
    {
      title: "05 min. drive - Capital Amaravati",
      imageUrl: landMark4,
    },
  ];

  const rightSideImgs = [
    {
      title: "05 min. drive - Amaravati Temple",
      imageUrl: landMark5,
    },
    {
      title: "02 min. drive - Vaikuntapuram to Kotikalapudi Iconic Bridge",
      imageUrl: landMark6,
    },
    {
      title: "05 min. drive - Agricultural Research Centre",
      imageUrl: landMark7,
    },
    {
      title: "10 min. drive - VIT University & SRM University",
      imageUrl: landMark8,
    },
  ];

  return (
    <>
      <div className="container-fluid py-5 location-container">
        <div className="container">
          <div className="LocationTitle">
            <p>Location Map</p>
          </div>
          <div
            className="MapImage"
            // data-aos="zoom-in"
          >
            <img
            //   src={`https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2Fa4a12015d91a4d8ab120f0392f97ce03`}
            src={Location}
              alt="mapImage"
              className="image-fluid w-100"
            />
          </div>

          <div
            className="landMarkCard py-5 mt-5"
            // data-aos="zoom-in"
          >
            <div>
              <p className="labMark">
                Close Proximity to Key Landmark Destinations
              </p>
              <p className="landMarkDesc">
                Pedamadduru, a picturesque village in the Amaravathi Mandal
              </p>
            </div>

            <div className="row">
              <div
                className="col-12 col-md-6 mb-3"
                // data-aos="fade-down"
              >
                <div className="d-flex flex-column">
                  {leftSideImgs.map((leftImg, index) => (
                    <div key={index} className="p-2 d-flex align-items-center">
                      <img
                        src={leftImg.imageUrl}
                        alt={leftImg.title}
                        className="me-2"
                        style={{ width: "50px", height: "50px" }}
                      />
                      <p className="mb-0 mx-4 landMarkCardTitle">
                        {leftImg.title}
                      </p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="col-12 col-md-6 mb-3"
                // data-aos="fade-up"
              >
                <div className="d-flex flex-column">
                  {rightSideImgs.map((rightImg, index) => (
                    <div key={index} className="p-2 d-flex align-items-center">
                      <img
                        src={rightImg.imageUrl}
                        alt={rightImg.title}
                        className="me-2"
                        style={{ width: "50px", height: "50px" }}
                      />
                      <p className="mb-0 mx-4 landMarkCardTitle">
                        {rightImg.title}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationMap;
